// extracted by mini-css-extract-plugin
module.exports =  {"root":"z8wwXRcmUyl43MkZwiri"};